import React from 'react';

import { useNodeDom } from 'craft/hooks';
import { useViewportBreakpoint } from 'craft/state';

import { SelectedToolbarMenuCallout } from './SelectedToolbarMenuCallout';
import { ToolbarMenuBody } from './ToolbarMenuBody';

export const SelectedToolbarMenu = ({ nodeId }: { nodeId: string }) => {
  // make sure we reposition the bar when we change the viewport
  const viewportBreakpoint = useViewportBreakpoint();
  const nodeDom: HTMLElement | null = useNodeDom(nodeId);
  // don't display the toolbar if there element is hidden
  if (!nodeDom || nodeDom.style.display === 'none') {
    return null;
  }

  return (
    <SelectedToolbarMenuCallout key={viewportBreakpoint} dom={nodeDom} isNodeToolbar>
      <ToolbarMenuBody />
    </SelectedToolbarMenuCallout>
  );
};
